var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-map-tabs__panel",
      attrs: {
        "aria-labelledby": _vm.tabId,
        hidden: !_vm.activeTab,
        id: _vm.panelId,
        role: "tabpanel",
        tabindex: "0"
      }
    },
    [
      _c(
        "div",
        { staticClass: "c-map-tabs__panel-inner" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3cd5d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3cd5d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/MapTab.vue
// module id = 668
// module chunks = 0